/* eslint-disable camelcase */
import { routes, empty, type } from "routopia";

const systemRoot = "";
const apiRoot = systemRoot + "/api";
const dataRoot = systemRoot + "/static/data";

/**
 * APIのURL定義。
 */
export const apiUrls = routes(apiRoot, {
    /** 7.3.1 震源情報検索API */
    "/sources/search": {
        post: empty,
    },

    /** 7.3.3 震源情報詳細取得API */
    "/sources/[eqSourceId]": {
        params: {
            eqSourceId: type as string,
        },
    },

    /** 7.3.2 観測点情報検索API */
    "/sites/search": {
        post: empty,
    },

    /** 7.3.4 観測点情報詳細取得API */
    "/sites/[siteId2]": {
        params: {
            siteId2: type as string,
        },
    },

    /** 7.3.5 波形情報取得API */
    "/waves": {
        queries: {
            siteid2: type as string | undefined,
            eq_source_id: type as string | undefined,
        },
    },

    /** 7.3.6 フラットファイル作成API */
    "/flats/create": {
        post: empty,
    },

    /** 7.3.7 フラットファイル作成状況確認API */
    "/flats/status/[jobId]": {
        params: {
            jobId: type as string,
        },
    },
});

/**
 * 静的ファイルのURL定義。
 */
export const dataFileUrls = routes(dataRoot, {
    /** お知らせ */
    "/news/news.json": empty,
});

/**
 * ページのURL定義。
 */
export const pageUrls = routes(systemRoot, {
    /** ランディング */
    "/": empty,

    /** 震源検索 */
    "/event/search": empty,

    /** 震源詳細 */
    "/event/[eqSourceId]": {
        params: {
            eqSourceId: type as string,
        },
    },

    /** 観測点検索 */
    "/station/search": empty,

    /** 観測点詳細 */
    "/station/[siteid2]": {
        params: {
            siteid2: type as string,
        },
    },

    /** フラットファイル検索 */
    "/flats": empty,

    /** お知らせ */
    "/notice": empty,

    /** FAQ */
    "/faq": empty,

    /** 利用規約 */
    "/terms": empty,
});
